import { cva } from 'class-variance-authority';

export const inputVariant = cva('!p-4 focus:outline-none', {
  variants: {
    isInvalid: {
      false: '!border-gray-400',
      true: '!border-red-500 !bg-red-50 !text-red-500',
    },
    noBorder: {
      true: '!border-0',
    },
  },
});
